export interface EditorUploadsState {
	reload_required: boolean;
}

export enum EditorUploadsMutation {
	SET_RELOAD_REQUIRED = 'SET_RELOAD_REQUIRED',
	UNSET_RELOAD_REQUIRED = 'UNSET_RELOAD_REQUIRED',
}

type EditorUploadsPayloadByMutationMapGeneric = {[key in EditorUploadsMutation]: any};
export interface EditorUploadsPayloadByMutationMap extends EditorUploadsPayloadByMutationMapGeneric {
	// scene
	[EditorUploadsMutation.SET_RELOAD_REQUIRED]: undefined;
	[EditorUploadsMutation.UNSET_RELOAD_REQUIRED]: undefined;
}

export const EditorUploadsStateModule = {
	namespaced: true,
	state(): EditorUploadsState {
		return {
			reload_required: false,
		};
	},

	mutations: {
		[EditorUploadsMutation.SET_RELOAD_REQUIRED]: (
			state: EditorUploadsState,
			payload: EditorUploadsPayloadByMutationMap[EditorUploadsMutation.SET_RELOAD_REQUIRED]
		) => {
			state.reload_required = true;
		},
		[EditorUploadsMutation.UNSET_RELOAD_REQUIRED]: (
			state: EditorUploadsState,
			payload: EditorUploadsPayloadByMutationMap[EditorUploadsMutation.UNSET_RELOAD_REQUIRED]
		) => {
			state.reload_required = false;
		},
	},
};
